import { Header } from "../Header";
import { Footer } from "../Footer";

import { localizationService, getText } from '../../services/localization.js';

import styles from './ContactUs.module.css';

export const ContactUs = () => {
  return (
    <div>
      <Header />
      <div className="container">
        <div className={styles.contactWrapper}>
          <div className={styles.details}>
            <div className={styles.detailsGroup}>
              <h3>{getText('الموقع:', 'Location:')}</h3>
              <p>{getText('عمان - الأردن ، خلدا - دوار السكر', 'Amman - Jordan, Khalda - Al Sukkar circle:')}</p>
            </div>
            <div className={styles.detailsGroup}>
              <h3>{getText('هاتف:', 'Telphone:')}</h3>
              <p>+962 6 551 4115</p>
              <p>+962 79 9042825</p>
            </div>
            <div className={styles.detailsGroup}>
              <h3>{getText('البريد الإلكتروني:', 'Email:')}</h3>
              <a href="mailto:abushaqdam@yahoo.com">abushaqdam@yahoo.com</a> 
            </div>
            <div className={styles.detailsGroup}>
              <a className={styles.socialIcons} href="https://www.facebook.com/AbuShaqdam/" target="_blank">
                <img src="https://storage.googleapis.com/door-assets/site/others/facebook_icon.png" alt="facebook" />
              </a> 
              <a className={styles.socialIcons} href="https://www.instagram.com/abushaqdam_sdoors/?hl=en" target="_blank">
                <img src="https://storage.googleapis.com/door-assets/site/others/Instagram_icon.png" alt="instagram" />
              </a> 
              <a className={styles.socialIcons} href="https://twitter.com/abushaqdam_sd" target="_blank">
                <img src="https://storage.googleapis.com/door-assets/site/others/twitter_logo.png" alt="twitter" />
              </a> 
            </div>
          </div>
          <iframe
            className={styles.map}
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d422.9919878504818!2d35.849593!3d31.989752999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3615eaeb2f312e85!2sAbushaqdam%20Security%20Doors!5e0!3m2!1sen!2sjo!4v1647522827819!5m2!1sen!2sjo"
            loading="lazy"
          >
          </iframe>
        </div>
      </div>
      <Footer />
    </div>
  );
};
